import AdminSections from './AdminSections';
import ValidatedForm from '../forms/ValidatedForm';
import FieldLabel, { RequiredFieldsNote } from '../forms/FieldLabel';
import AdminPublishBar from "./AdminPublishBar";

export default function PresskitEditor({ content, longBioDraft, saving, dirty, onChange, onDiscard, onLongBioChange, onSubmit }) {
  return (
    <ValidatedForm className="admin-editor" onSubmit={onSubmit}>
      <div className="admin-editor-heading">
        <div>
          <p className="admin-kicker">Page content</p>
          <h2>Press Kit copy</h2>
          <p>Changes remain private until you publish them.</p>
        </div>
        <a href="/presskit" target="_blank" rel="noopener noreferrer">View page</a>
      </div>
      <RequiredFieldsNote />
      <AdminSections label="Press Kit sections">
      <fieldset className="admin-form-section" data-section-label="Introduction">
        <legend>Page introduction</legend>
        <FieldLabel>Kicker<input value={content.kicker} onChange={(event) => onChange("kicker", event.target.value)} required /></FieldLabel>
        <FieldLabel>Page title<input value={content.title} onChange={(event) => onChange("title", event.target.value)} required /></FieldLabel>
        <FieldLabel>Introduction<textarea rows="4" value={content.intro} onChange={(event) => onChange("intro", event.target.value)} required /></FieldLabel>
      </fieldset>
      <fieldset className="admin-form-section" data-section-label="Short biography">
        <legend>Short biography</legend>
        <FieldLabel>Short bio<textarea rows="10" value={content.shortBio} onChange={(event) => onChange("shortBio", event.target.value)} required /></FieldLabel>
      </fieldset>
      <fieldset className="admin-form-section" data-section-label="Long biography">
        <legend>Long biography</legend>
        <FieldLabel>Long bio paragraphs <small>Separate paragraphs with a blank line.</small><textarea rows="12" value={longBioDraft} onChange={(event) => onLongBioChange(event.target.value)} required /></FieldLabel>
      </fieldset>
      </AdminSections>
      <AdminPublishBar dirty={dirty} saving={saving} label="Publish Press Kit" onDiscard={onDiscard} />
    </ValidatedForm>
  );
}
